import { Api } from "api";

export const getChats = async (search: URLSearchParams, page?: number) => {
  let url = "/chat/v1/channels/admin";
  let params = search ? `?${search}` : "";
  const res = await Api.get(`${url}${params}`, {
    params: { page },
  });
  return res.data;
};

export const getChatById = async (id: string | undefined) => {
  const res = await Api.get(`/chat/v1/channels/admin/${id}`);
  return res.data;
};

export const deleteChat = async (id: string) => {
  const res = await Api.delete(`/chat/v1/channels/admin/${id}`);
  return res.data;
};

export const getChatMembers = async (id: string | undefined) => {
  const res = await Api.get(`/chat/v1/channels/admin/${id}/members`);
  return res.data;
};

export const getChatPosts = async (id: string | undefined) => {
  const res = await Api.get(`/chat/v1/channels/admin/${id}/posts`);
  return res.data;
};

export const getChatFiles = async (channelId: string | undefined) => {
  const res = await Api.get(`/files/v1/${channelId}`);
  return res.data;
};
